import { Material } from "@/components/materials/MaterialCard";

export const sampleMaterials: Material[] = [
  {
    id: "1",
    name: "Italian Carrara Marble",
    category: "Stone",
    price: 185,
    priceUnit: "sq ft",
    image: "https://images.unsplash.com/photo-1618220179428-22790b461013?w=600&h=600&fit=crop",
    colors: ["#f5f5f5", "#e0e0e0", "#9e9e9e"],
    texture: "Smooth",
    isFavorite: true,
  },
  {
    id: "2",
    name: "Walnut Hardwood Flooring",
    category: "Wood",
    price: 12,
    priceUnit: "sq ft",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=600&fit=crop",
    colors: ["#5d4e37", "#8b7355", "#a0826d"],
    texture: "Textured",
  },
  {
    id: "3",
    name: "Brushed Brass Hardware",
    category: "Metal",
    price: 45,
    priceUnit: "piece",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=600&fit=crop",
    colors: ["#d4af37", "#c5a028", "#b8962a"],
    texture: "Glossy",
  },
  {
    id: "4",
    name: "Belgian Linen Upholstery",
    category: "Fabric",
    price: 89,
    priceUnit: "yard",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=600&fit=crop",
    colors: ["#f5f5dc", "#ebe0c5", "#d4c4a8"],
    texture: "Textured",
    isFavorite: true,
  },
  {
    id: "5",
    name: "Porcelain Floor Tile",
    category: "Ceramic",
    price: 8,
    priceUnit: "sq ft",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&h=600&fit=crop",
    colors: ["#ffffff", "#f5f5f5", "#e8e8e8"],
    texture: "Matte",
  },
  {
    id: "6",
    name: "Venetian Glass Mosaic",
    category: "Glass",
    price: 65,
    priceUnit: "sq ft",
    image: "https://images.unsplash.com/photo-1615971677499-5467cbab01c0?w=600&h=600&fit=crop",
    colors: ["#4a90a4", "#6bb5c9", "#89d4e8", "#2c5f6e"],
    texture: "Glossy",
  },
  {
    id: "7",
    name: "Reclaimed Oak Planks",
    category: "Wood",
    price: 18,
    priceUnit: "sq ft",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=600&fit=crop",
    colors: ["#8b7355", "#a0826d", "#6b5344"],
    texture: "Rough",
  },
  {
    id: "8",
    name: "Quartz Countertop",
    category: "Composite",
    price: 95,
    priceUnit: "sq ft",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&h=600&fit=crop",
    colors: ["#f8f8f8", "#e5e5e5", "#d3d3d3"],
    texture: "Smooth",
  },
];
